/* =========================
   CONFIG
========================= */

const cookieCustomizedData = {
  cookieBanner: {
    variants: {
      original: {
        title:"We use cookies to improve your experience, show relevant content, and analyze traffic. By clicking 'Accept Cookies', you agree to our use of cookies. You can manage your preferences anytime.",
        buttons: {
          acceptButtonText: "Accept & Continue",
        },
      },
      friendly: {
        title: "Help us remember your favorites so you can shop faster next time.",
        buttons:{
          acceptButtonText: "YES, SOUNDS GOOD",
        },
        header: "A smoother shopping trip",
        introTitle: "Personalize your visit",
        introDescription:
          "We use cookies to keep your bag ready and remember your sizes. It’s all about making your life easier.",
      },
      witty: {
        title:"We've got cookies—the digital kind. They help us show you only the stuff you actually like.",
        buttons:{
          acceptButtonText: "I'M IN",
        },
        header: "The 'No Boring Ads' Promise",
        introTitle: "Digital cookies for a better browse",
        introDescription:
          "They don’t taste great, but they help us skip the stuff you don't care about and show you the good stuff.",
      },
      minimalist: {
        title:"You're in control. We use cookies to analyze traffic and provide a seamless checkout.",
        buttons:{
          acceptButtonText: "ACCEPT & CONTINUE",
        },
        header: "Your Data, Your Choice",
        introTitle: "Total Transparency",
        introDescription:
          "We only use data to improve your checkout speed and site stability. No surprises, just a better site.",
      },
    },
  },

  cookieCopy: {
    header: "Let's make your shopping experience even better",
    introTitle: "We use cookies to personalise your experience and improve our site",
    introDescription:
      "Cookies help us remember your preferences, improve site performance, and show relevant offers. You can change your choices anytime.",

    categories: {
      required:
        "These cookies are necessary for the website to function properly, including secure login and adding items to your cart.",
      personalization:
        "Helps us remember your preferences and show products that are more relevant to you.",
      analytics:
        "Helps us understand how the website is used so we can improve performance and usability.",
      marketing:
        "Helps us show you relevant offers and promotions, including on social media and other platforms.",
    },

    buttons: {
      acceptHelper: "Recommended for the best experience",
      reject: "Reject",
      save: "Save my choices",
    },
  },
};

/* =========================
   HELPERS
========================= */

const setText = (selector, text) => {
  const el = document.querySelector(selector);
  if (el) el.textContent = text;
};

const waitAndSetText = (selector, text) => {
  waitForElem(selector, () => setText(selector, text));
};

/* =========================
   PREFS MODAL LOGIC
========================= */

const changeTextContents = () => {
  const { cookieCopy } = cookieCustomizedData;

  setText("#shopify-pc__prefs__header-title", cookieCopy.header);
  setText(".shopify-pc__prefs__intro-main h3", cookieCopy.introTitle);
  setText(".shopify-pc__prefs__intro-main p", cookieCopy.introDescription);

  setText("#shopify-pc__prefs__essential p", cookieCopy.categories.required);
  setText("#shopify-pc__prefs__preferences p", cookieCopy.categories.personalization);
  setText("#shopify-pc__prefs__analytics p", cookieCopy.categories.analytics);
  setText("#shopify-pc__prefs__marketing p", cookieCopy.categories.marketing);

  setText("#shopify-pc__prefs__header-decline", cookieCopy.buttons.reject);
  setText("#shopify-pc__prefs__header-save", cookieCopy.buttons.save);

  addAcceptHelperText();
};

const addAcceptHelperText = () => {
  const acceptBtn = document.querySelector("#shopify-pc__prefs__header-accept");
  if (!acceptBtn || acceptBtn.querySelector(".helper-text")) return;

  const helper = document.createElement("div");
  helper.className = "helper-text";
  helper.textContent = cookieCustomizedData.cookieCopy.buttons.acceptHelper;

  Object.assign(helper.style, {
    fontSize: "10px",
    opacity: "0.7",
    marginTop: "4px",
    position: "absolute",
    top: "-24px",
    left: "50%",
    transform: "translate(-50%, 0)",
    color: "#000",
  });

  acceptBtn.appendChild(helper);
};

const checkAllItems = () => {
  document
    .querySelectorAll(
      ".shopify-pc__prefs__options .shopify-pc__prefs__option input:not(#shopify-pc__prefs__essential input)"
    )
    .forEach((input) => {
      if (!input.checked) input.click();
    });
};

const repositionHeaderActions = () => {
  const headerActions = document.querySelector(".shopify-pc__prefs__header-actions");
  const target = document.querySelector(".shopify-pc__prefs__options");
  if (headerActions && target) {
    target.insertAdjacentElement("afterend", headerActions);
  }
};

/* =========================
   EVENT BINDINGS
========================= */

waitForElem("#shopify-pc__banner__btn-manage-prefs", () => {
  document
    .querySelector("#shopify-pc__banner__btn-manage-prefs")
    .addEventListener("click", () => {
      checkAllItems();
      changeTextContents();
      repositionHeaderActions();
    });
});

/* =========================
   BANNER TEXT
========================= */

const bannerVariant = cookieCustomizedData.cookieBanner.variants.original;

waitAndSetText(".shopify-pc__banner__body p", bannerVariant.title);
waitAndSetText(
  "#shopify-pc__banner__btn-accept",
  bannerVariant.buttons.acceptButtonText
);
